import { Button } from "@/components/ui/button/button";

import { Island } from "../island";

type Props = {
	formTitle: string;
	formDescription?: string;
	children: React.ReactNode;

	primaryButtonText: string;
	disabled?: boolean;
	handlePrimaryButtonClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

	otherInfo?: React.ReactNode;
};

export const AuthForm = ({
	children,
	formTitle,
	formDescription,
	disabled,
	handlePrimaryButtonClick,
	primaryButtonText,
	otherInfo,
}: Props) => {
	return (
		<Island>
			<div className="space-y-2">
				<h1 className="text-gray-900 text-xl font-bold leading-tight tracking-tight md:text-2xl">{formTitle}</h1>
				{formDescription ? <p className="text-sm leading-relaxed text-gray-600">{formDescription}</p> : null}
			</div>

			<div className="space-y-14">
				<div className="space-y-9">{children}</div>

				<Button variant={"default"} disabled={disabled} onClick={handlePrimaryButtonClick} className="w-full">
					{primaryButtonText}
				</Button>
			</div>

			{otherInfo}
		</Island>
	);
};
